import {wrap} from '@codeurs/front'
import React from 'react'
import {PageData} from '../../types'
import {style} from '../../util/style'
import {Breadcrumbs} from '../layout/Breadcrumbs'
import {Hero, HeroType} from '../layout/Hero'
import {Layout} from '../layout/Layout'
import {FaqOverview, FaqOverviewType} from './faq/FaqOverview'

const styles = style('faq')

type FaqType = {
	hero: HeroType
} & FaqOverviewType

export const Faq: React.FC<PageData & FaqType> = wrap(Layout)(({...props}) => {
	const {parents, title, hero, categories} = props

	return (
		<div className={styles()}>
			<Hero {...hero} title={(hero && hero.title) || title} />
			<Breadcrumbs parents={parents} title={title} />
			<FaqOverview categories={categories} />
		</div>
	)
})
